/* eslint-disable */
import {
  Object3DFacade,
  Group3DFacade
} from 'troika-3d'
import {
  Mesh,
  Color,
  Line,
  LineBasicMaterial,
  Geometry,
  MeshBasicMaterial,
  ShaderMaterial,
  DoubleSide,
  Vector3,
} from 'three'
import {
  scaleSequential
} from 'd3-scale'
import {
  interpolateRgbBasis
} from 'd3-interpolate'
import PathDrawingContext from '../../utils/PathDrawingContext'
import {
  GRAPH_STROKE_STYLES,
  GRAPH_FILL_STYLES,
  GRAPH_AXES,
  D3_CURVE_INTERPOLATORS,
  CURVE_OPTIONS
} from '../../constants'

const SMOOTH_CURVE = true

const DEFAULT_STROKE_WIDTH = 1.0
const DEFAULT_STROKE_OPACITY = 1.0
const DEFAULT_FILL_OPACITY = 0.8 //0.5
const DEFAULT_COLOR = new Color(0x3ba7db)
const DEFAULT_STROKE_STYLE = GRAPH_STROKE_STYLES.SOLID
const DEFAULT_FILL_STYLE = GRAPH_FILL_STYLES.GRADIENT


class FillFacade extends Object3DFacade {
  constructor(parent) {
    const mesh = new Mesh(
      new Geometry(),
      new MeshBasicMaterial({
        fog: false,
        side: DoubleSide,
        opacity: DEFAULT_FILL_OPACITY,
        color: 0xff0000, //DEFAULT_COLOR,
        transparent: true,
        wireframe: true
      })
    )

    super(parent, mesh)
  }

  afterUpdate() {
    const self = this.threeObject

    self.geometry.vertices = this.path
    self.geometry.verticesNeedUpdate = true

    super.afterUpdate()
  }
}

class StrokeFacade extends Object3DFacade {
  // constructor(parent) {
  //   const mesh = new Mesh(
  //     new Geometry(),
  //     new MeshBasicMaterial({
  //     // new LineBasicMaterial({
  //       fog: false,
  //       side: DoubleSide,
  //       opacity: DEFAULT_STROKE_OPACITY,
  //       color: DEFAULT_COLOR,
  //       transparent: true,
  //       wireframe: true
  //     })
  //   )

  //   // const BOX_SIZE = 80

  //   // const geometry = new BoxBufferGeometry(BOX_SIZE, BOX_SIZE, BOX_SIZE)
  //   // const material = new MeshPhongMaterial({
  //   //   color: 0xff0000,
  //   //   opacity: 0.6,
  //   //   side: DoubleSide,
  //   //   transparent: true
  //   // })

  //   // const mesh = new Mesh(geometry, material)

  //   super(parent, mesh)
  // }


  constructor(parent) {
    const line = new Line(
      new Geometry(),
      new LineBasicMaterial({
        fog: false,
        side: DoubleSide,
        opacity: DEFAULT_STROKE_OPACITY,
        color: DEFAULT_COLOR,
        transparent: true,
        // wireframe: true
      })
    )

    super(parent, line)
  }

  afterUpdate() {
    const self = this.threeObject

    // this.threeObject.geometry = new Geometry(this.path)
    this.threeObject.geometry.vertices = this.path
    this.threeObject.geometry.verticesNeedUpdate = true
    this.threeObject.geometry.verticesNeedUpdate = true
    this.threeObject.geometry.elementsNeedUpdate = true
    this.threeObject.geometry.morphTargetsNeedUpdate = true
    this.threeObject.geometry.uvsNeedUpdate = true
    this.threeObject.geometry.normalsNeedUpdate = true
    this.threeObject.geometry.colorsNeedUpdate = true
    this.threeObject.geometry.tangentsNeedUpdate = true
    this.threeObject.geometry.computeBoundingSphere()

    this.threeObject.material.color = this.color

    console.log('StrokeFacade afterUpdate', self)
    super.afterUpdate()
  }
}


export default class StreamArea extends Group3DFacade {

  // Defaults
  strokeStyle = DEFAULT_STROKE_STYLE
  strokeWidth = DEFAULT_STROKE_WIDTH
  strokeOpacity = DEFAULT_STROKE_OPACITY

  fillStyle = DEFAULT_FILL_STYLE
  fillOpacity = DEFAULT_FILL_OPACITY

  dashRatio = 0.02
  dashArray = 0.5
  dashOffset = 0.0

  strokeSizeAttenuation = false

  // Private
  _activeStrokeStyle = DEFAULT_STROKE_STYLE
  _activeFillStyle = DEFAULT_FILL_STYLE

  _latestIsPerspectiveCam = null
  _latestNumStrokeVertices = 0

  constructor(parent) {
    super(parent)
    const {
      strokeStyle,
      fillStyle
    } = this

    this.children = []

    if (strokeStyle) {
      this.strokeRef = {
        x: 0,
        y: 0,
        z: 0,
        facade: StrokeFacade,
        color: new Color(0xffffff),
        // path: upperPathVerts.map(([x, y]) => new Vector3(x, y, 0)),
        onMouseOver: this.handleStrokeMouseOver,
        onMouseOut: this.handleStrokeMouseOut,
      }
      this.children.push(this.strokeRef)
    }
    if (fillStyle) {
      this.fillRef = {
        x: 0,
        y: 0,
        z: 0,
        facade: FillFacade,
        color: new Color(0xffffff),
        // path: upperPathVerts.map(([x, y]) => new Vector3(x, y, 0)),
        onMouseOver: this.handleFillMouseOver,
        onMouseOut: this.handleFillMouseOut,
      }
      this.children.push(this.strokeRef)
    }
  }

  static get2DCurvePoints = (pointVec3s, interpolateFn) => {
    const pathBuilder = new PathDrawingContext()
    let interpolator = D3_CURVE_INTERPOLATORS[interpolateFn] ||  D3_CURVE_INTERPOLATORS[interpolateFn]

    interpolator = interpolator(pathBuilder)
    interpolator.lineStart()
    if (pointVec3s) {
      for (let i = 0, len = pointVec3s.length; i < len; i += 2) {
        interpolator.point(pointVec3s[i], pointVec3s[i + 1])
      }
    }
    interpolator.lineEnd()
    return pathBuilder.getPoints()
  }

  _timestampToX(timestamp) {
    const {
      xScale,
      minX,
      maxX,
      xExponent,
      width
    } = this
    if (xScale) {
      return xScale(timestamp)
    }
    let output = (timestamp - minX) / (maxX - minX)
    if (xExponent) {
      output = Math.pow(output, xExponent)
    }
    return width * output
  }

  _valueToY(value) {
    const {
      yScale,
      minY,
      maxY,
      strokeWidth,
      height
    } = this
    if (yScale) {
      return yScale(value)
    }
    const yMargin = Math.floor(strokeWidth / 2)
    const topY = height - yMargin
    const botY = yMargin
    const output = maxY === minY ? botY : botY - (botY - topY) * (value - minY) / (maxY - minY)
    return isNaN(output) ? 0 : output
  }

  _valueToColor(value) {
    const {
      colorScale
    } = this
    return colorScale(value)
  }

  handleStrokeMouseOver = e => {
    console.log('STROKE mouseover')

  }

  handleStrokeMouseOut = e => {
    console.log('STROKE mouseout')

  }

  afterUpdate() {
    const {
      values,
      fillColor,
      fillStyle,
      strokeColor,
      strokeStyle,
      strokeWidth,
      strokeOpacity,
      fillOpacity,
      width,
      height,
      isPerspectiveCamera,
      pathInterpolate,
      strokeSizeAttenuation,
      // dashDistance,
      // dashSmooth,
      // dashSteps,
      dashOffset,
      dashArray,
      dashRatio,
      xScale,
    } = this // Troika pseudo-props


    if (!fillColor && !strokeColor) {
      throw new Error('StreamAreaD3: line must have a fillColor AND/OR strokeColor. Both were falsy.')
    }

    // Fill Color may be specified as the COLOR/CHROMA axis/scale
    // TODO allow stroke to use this as well
    const isFillColorScale = fillColor === GRAPH_AXES.COLOR

    const _pathInterpolation = SMOOTH_CURVE ? pathInterpolate : 'linear'

    // if (strokeStyle && strokeStyle !== this._activeStrokeStyle) {
    //   stroke.material = STROKE_MATERIALS[strokeStyle]
    //   this._activeStrokeStyle = strokeStyle
    // }
    // if (fillStyle && fillStyle !== this._activeFillStyle) {
    //   fill.material = FILL_MATERIALS[fillStyle]
    //   this._activeFillStyle = fillStyle
    // }
    // const {
    //   geometry: fillGeometry,
    //   material: fillMaterial
    // } = fill
    // const {
    //   geometry: strokeGeometry,
    //   material: strokeMaterial
    // } = stroke

    const _values = Object.values(values)
    const _numValues = _values.length

    const upperPoints = new Array(_numValues * 2) // Flat 2D array of x/y points
    const lowerPoints = new Array(_numValues * 2) // Flat 2D array of x/y points
    const upperPointColors = new Array(_numValues)
    // const upperPointColorsXs = new Array(_numValues)

    // for (var i = 0; i < _numValues; i++) {
    //   const val = _values[i]
    //   const x = this._timestampToX(val.timestamp) //xScale(val.timestamp)
    //   upperPoints[i * 2] = x
    //   upperPoints[i * 2 + 1] = this._valueToY(val.y0)
    //   lowerPoints[i * 2] = x
    //   lowerPoints[i * 2 + 1] = this._valueToY(val.y1)
    //   // upperPointColorsXs[i] = x
    //   if (isFillColorScale) {
    //     upperPointColors[i] = this._valueToColor(val.colorValue)
    //   }
    // }

    for (var i = 0; i < _numValues; i++) {
      const val = _values[i]
      const x = this._timestampToX(val.timestamp) //xScale(val.timestamp)
      const y0 = this._valueToY(val.y0)
      const y1 = this._valueToY(val.y1)

      upperPoints[i * 2] = x
      upperPoints[i * 2 + 1] = this._valueToY(val.y0)
      lowerPoints[i * 2] = x
      lowerPoints[i * 2 + 1] = this._valueToY(val.y1)
      // upperPointColorsXs[i] = x
      if (isFillColorScale) {
        upperPointColors[i] = this._valueToColor(val.colorValue)
      }
    }

    const upperPathVerts = StreamArea.get2DCurvePoints(upperPoints, _pathInterpolation)
    const lowerPathVerts = StreamArea.get2DCurvePoints(lowerPoints, _pathInterpolation).reverse() // Clockwise drawing order
    const fillVertices = upperPathVerts.concat(lowerPathVerts)

    // Interpolate point colors -> vert colors
    // Use output X range as input domain for color map
    const xToColorScale = isFillColorScale
      ? scaleSequential(interpolateRgbBasis(upperPointColors)).domain(xScale.range())
      : null





    // console.log('streamarea afterupdate')
    if (this.strokeRef) {
      // this.strokeRef.path = upperPathVerts.map(([x, y]) => new Vector3(x, y, 0))
      this.strokeRef.path = _values.map(val => new Vector3(
        this._timestampToX(val.timestamp),
        this._valueToY(val.y1),
        0
      ))
      this.strokeRef.color = new Color(strokeColor)
    }
    // if (this.fillRef) {
    //   this.fillRef.path = fillVertices.map(([x, y]) => new Vector3(x, y, 0))
    //   this.fillRef.color = new Color(fillColor)
    // }

    // // "render"
    // this.children = [
    //   strokeStyle && strokeColor && {
    //     x: 0,
    //     y: 0,
    //     z: 0,
    //     facade: StrokeFacade,
    //     color: new Color(0xffffff),
    //     path: upperPathVerts.map(([x, y]) => new Vector3(x, y, 0)),
    //     onMouseOver: this.handleStrokeMouseOver,
    //     onMouseOut: this.handleStrokeMouseOut,
    //   },
    //   // fillStyle && fillColor && {
    //   //   facade: FillFacade,
    //   //   color: fillColor,
    //   //   path: fillVertices.map(([x, y]) => new Vector3(x, y, 0)),
    //   // }
    // ]














    // Simple triangulation based on known counterclockwise layout of vertices
    // const endIdx = fillVertices.length - 1
    // const midPoint = Math.floor(endIdx / 2)
    // const numTriangles = endIdx - 1
    // const flatTriangles = new Uint16Array(numTriangles * 3)
    // for (var t = 0; t < numTriangles; t++) {
    //   // Skip "midpoint" that would result in a duplicate triangle
    //   const vI = t >= midPoint ? t + 1 : t
    //   flatTriangles[t * 3] = vI
    //   flatTriangles[t * 3 + 1] = vI + 1
    //   flatTriangles[t * 3 + 2] = endIdx - (vI + 1)
    // }

    // // Flatten vertices for BufferGeometry
    // const numVerts = fillVertices.length
    // const flatVertices = new Float32Array(numVerts * 3)
    // const flatNormals = new Float32Array(numVerts * 3)
    // const maxYs = new Float32Array(numVerts)
    // const minYs = new Float32Array(numVerts)
    // const flatColors = new Float32Array(numVerts * 3)
    // let graphMaxY = 0 // Max y value across whole x-span
    // // const strokeVertices = []
    // const numStrokeVertices = numVerts / 2
    // const strokeVerticesF32 = new Float32Array(numStrokeVertices * 3)


    // for (var k = 0; k < numVerts; k++) {
    //   const [x, y] = fillVertices[k]
    //   const z = 0
    //   flatVertices[k * 3] = x
    //   flatVertices[k * 3 + 1] = y
    //   flatVertices[k * 3 + 2] = z

    //   flatNormals[k * 3] = 1.0
    //   flatNormals[k * 3 + 1] = -1.0
    //   flatNormals[k * 3 + 2] = -1.0

    //   // Store max/min y-values per x "column" for shader pseudo-gradient generation
    //   const isTopRow = k >= numVerts / 2
    //   const oppositeIdx = numVerts - 1 - k
    //   const oppositeY = fillVertices[oppositeIdx][1]
    //   maxYs[k] = isTopRow ? y : oppositeY
    //   minYs[k] = isTopRow ? oppositeY : y

    //   graphMaxY = Math.max(graphMaxY, y)

    //   if (isTopRow) {
    //     // strokeVertices.push(x, y, z)
    //     const m = k - (numVerts / 2) // Re-zero indices for stroke
    //     strokeVerticesF32[m * 3] = x
    //     strokeVerticesF32[m * 3 + 1] = y
    //     strokeVerticesF32[m * 3 + 2] = z
    //   }

    //   let _color = null
    //   if (xToColorScale) {
    //     _color = new Color(xToColorScale(x))
    //   }
    //   else {
    //     _color = new Color(fillColor || DEFAULT_COLOR)
    //   }
    //   const {r, g, b} = _color
    //   flatColors[k * 3] = r
    //   flatColors[k * 3 + 1] = g
    //   flatColors[k * 3 + 2] = b
    // }


    // // Update stroke



    // if (strokeColor) {
    //   if (this._activeStrokeStyle === GRAPH_STROKE_STYLES.BASIC) {
    //     // Basic stroke
    //     strokeMaterial.color = new Color(strokeColor)
    //     strokeMaterial.opacity = strokeOpacity
    //   } else {
    //     // MeshLine stroke
    //     if (numStrokeVertices !== this._latestNumStrokeVertices) {
    //       // Vertices size changed,
    //       // must reinitialize the MeshLine's internal BufferAttributes by deleting its cache
    //       delete this._upperStrokeMeshLineRef.attributes
    //     }

    //     // Update the mesh with the latest vertices
    //     this._upperStrokeMeshLineRef.setGeometry(strokeVerticesF32)

    //     // If the camera type has changed (or has not been read yet), update the MeshLineMaterial properties that depend upon it
    //     if (this._latestIsPerspectiveCam === null || this._latestIsPerspectiveCam !== isPerspectiveCamera) {
    //       this._latestIsPerspectiveCam = isPerspectiveCamera
    //       const currentCamera = this.getCameraFacade()
    //       strokeMaterial.uniforms.near.value = currentCamera.near
    //       strokeMaterial.uniforms.far.value = currentCamera.far
    //     }

    //     if (height !== this._lastHeight || width !== this._lastWidth) {
    //       strokeMaterial.uniforms.resolution.value = new Vector2(width, height)
    //       this._lastHeight = height
    //       this._lastWidth = width
    //     }

    //     strokeMaterial.uniforms.sizeAttenuation.value = strokeSizeAttenuation
    //     strokeMaterial.uniforms.opacity.value = strokeOpacity
    //     strokeMaterial.uniforms.color.value = new Color(strokeColor)
    //     strokeMaterial.uniforms.lineWidth.value = this._latestIsPerspectiveCam ? strokeWidth : strokeWidth * 0.01

    //     if (this._activeStrokeStyle === GRAPH_STROKE_STYLES.DASHED) {
    //       // strokeMaterial.uniforms.useDash.value = 1
    //       strokeMaterial.uniforms.dashOffset.value = dashOffset
    //       strokeMaterial.uniforms.dashRatio.value = dashRatio
    //       strokeMaterial.uniforms.dashArray.value = dashArray
    //     }
    //   }
    // }

    // if (fillColor) {
    //   // Update fill
    //   if (this._fillGeometryInitialized) {
    //     fillGeometry.attributes.position.setArray(flatVertices)
    //     fillGeometry.attributes.normal.setArray(flatNormals)
    //     fillGeometry.attributes.vertexMaxY.setArray(maxYs)
    //     fillGeometry.attributes.vertexMinY.setArray(minYs)
    //     fillGeometry.attributes.vertexColor.setArray(flatColors)

    //     fillGeometry.attributes.position.needsUpdate = true
    //     fillGeometry.attributes.normal.needsUpdate = true
    //     fillGeometry.attributes.vertexMaxY.needsUpdate = true
    //     fillGeometry.attributes.vertexMinY.needsUpdate = true
    //     fillGeometry.attributes.vertexColor.needsUpdate = true

    //     fillGeometry.index.setArray(flatTriangles)
    //     fillGeometry.index.needsUpdate = true
    //   }
    //   else {
    //     this._fillGeometryInitialized = true
    //     // Create buffer attributes
    //     fillGeometry.addAttribute('position', new BufferAttribute(flatVertices, 3))
    //     fillGeometry.addAttribute('normal', new BufferAttribute(flatNormals, 3))
    //     fillGeometry.addAttribute('vertexMaxY', new BufferAttribute(maxYs, 1))
    //     fillGeometry.addAttribute('vertexMinY', new BufferAttribute(minYs, 1))
    //     fillGeometry.addAttribute('vertexColor', new BufferAttribute(flatColors, 3)) // Vec3 colors
    //     fillGeometry.setIndex(new BufferAttribute(flatTriangles, 1))
    //   }

    //   fillGeometry.computeBoundingSphere()
    //   fillGeometry.verticesNeedUpdate = true
    //   fillGeometry.elementsNeedUpdate = true

    //   if (this._activeFillStyle === GRAPH_FILL_STYLES.BASIC) {
    //     // Basic material
    //     fillMaterial.color = new Color(fillColor)
    //     fillMaterial.opacity = fillOpacity
    //   } else {
    //     // Shader-based materials

    //     // fillMaterial.uniforms.color.value = new Color(fillColor)
    //     fillMaterial.uniforms.graphMaxY.value = graphMaxY // emulates SVG "userSpaceOnUse"
    //     fillMaterial.uniforms.gradientMaxOpacity.value = fillOpacity
    //   }

    //   this._latestNumStrokeVertices = numStrokeVertices
    // }

    super.afterUpdate()
  }

  destructor() {
    super.destructor()
    // TODO dispose fillGeometry/fillMaterial?
  }
}
